import { Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Icons } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'
import { useSettingUserInfoModal } from '@/core/membership/useSettingUserInfoModal'
import { getRegisterNewMembership } from '@/core/native/storage'

type RequiredMembershipInfoBoxProps = {
  visibleLink?: boolean
}

export const RequiredMembershipInfoBox: Organism<RequiredMembershipInfoBoxProps> =
  ({ visibleLink }) => {
    const { t } = useTranslation('personalInfoSettings')
    const [isRegisterNewMembership, setIsRegisterNewMembership] =
      useState<boolean>(false)
    const { showModal } = useSettingUserInfoModal()
    const [] = useState()

    useEffect(() => {
      ;(async () => {
        setIsRegisterNewMembership(await getRegisterNewMembership())
      })()
    }, [])

    return (
      <OrganismFrame
        sx={{
          p: 3,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'error.main',
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} pb={1}>
          <Icons.Info sx={{ width: 16, height: 16, color: 'error.main' }} />
          <Typography variant="subtitle2">
            {t('requireInfoTitle', 'お客様情報の登録が必要です')}
          </Typography>
        </Stack>
        <Typography variant="caption" component="p">
          {t(
            isRegisterNewMembership
              ? 'requireMembershipInfoDesc'
              : 'requireInfoDesc'
          )}
        </Typography>
        {visibleLink && (
          <Typography
            variant="caption"
            onClick={() => showModal()}
            width="fit-content"
            sx={{ display: 'block', color: 'primary.main', cursor: 'pointer' }}
            pt={1}
          >
            {t('enterYourInfo', '入力する')}
          </Typography>
        )}
      </OrganismFrame>
    )
  }
